<div
    class="sir-textarea-container"
    [ngClass]="{
        'has-value': control.value,
    }">
    <sirius-label [for]="id" textStyle="system" [textStyleSize]="labelSize()" textStyleColor="secondary">
        {{ label }}
        @if (validationService.isRequired(control)) {
            <span class="sir-required-asterisk" aria-hidden="true">*</span>
        }
    </sirius-label>
    <textarea
        class="sir-text-style-paragraph-m-default"
        [id]="id"
        [value]="control.value"
        [name]="name"
        [attr.data-identifier]="identifier"
        [attr.maxlength]="maxlength"
        (change)="onChange($any($event.target).value)"
        (input)="onChange($any($event.target).value)"
        (focus)="focused.set(true)"
        (blur)="focused.set(false); onTouched()"
        [ngClass]="{
            'is-invalid': (valid$ | async) === false,
            'has-validator': control.validator,
        }"></textarea>
</div>
<div class="sir-textarea-footer sir-text-style-system-s-default sir-text-style-color-secondary">
    <div class="sir-textarea-tooltip">{{ toolTip }}</div>
    <div class="sir-textarea-counter" data-cy="char-length">{{ control.value?.length ?? 0 }} / {{ maxlength }}</div>
</div>
